module.exports = __webpack_public_path__ + "img/elogo.d208741a.png";